module.exports = __webpack_public_path__ + "img/info-yellow.b9fa6ac5.png";